import { firebase, firestore } from '../utilities/firebase'
import errorTypes from '../enums/errorTypes'
import { errorOfType } from '../utilities/Errors/index'
import getCurrentUid from '../utilities/getCurrentUid'
import that from '../utilities/translationHelper'

const duplicateKitFromKitId = async ({ kitId: kitIdFrom }) => {
	try {
		const uid = getCurrentUid()

		// load
		const kitsCollRef = firestore.collection('kits')
		const kitDocSnap = await kitsCollRef.doc(kitIdFrom).get()
		// check for errors
		if (!kitDocSnap.exists) {
			return Promise.reject(errorOfType(errorTypes.NOTFOUND, kitIdFrom))
		}
		// get data
		const kit = kitDocSnap.data()
		if (kit.uid === uid) {
			// modify name if same user profile
			kit.name = that.context.translate('{name} (copy)', { name: kit.name })
		} else {
			// or set the new uid
			kit.uid = uid
		}
		// clear/set some data
		delete kit.algoliaIndexUpdated
		delete kit.countPosts
		delete kit.countOwned
		delete kit.countWanted
		kit.algoliaProcessingRequired = true

		// store kit
		const kitDocRef = kitsCollRef.doc()
		// put id in new kit
		const kitId = kitDocRef.id
		kit.kitId = kitId
		kit.createdTimestamp = firebase.firestore.FieldValue.serverTimestamp()
		kit.modifiedTimestamp = firebase.firestore.FieldValue.serverTimestamp()

		await kitDocRef.set(kit)

		// output
		return { kitId, kit }
	} catch (error) {
		throw errorOfType(errorTypes.UNKNOWNERROR, kitIdFrom, error)
	}
}

export default duplicateKitFromKitId



// WEBPACK FOOTER //
// ./src/dataservices/duplicateKitFromKitId.js